export enum NotificationPathsEnum {
  ROOT = "notifications",
}

export enum NotificationRoutesEnum {
  ROOT = "/notifications",
}
